import { ABOUT, BRAND } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/SectionHeading";

export const AboutGroup = () => (
  <section
    id="group"
    data-testid="about-section"
    className="relative isolate overflow-hidden border-t border-border/70 py-24 lg:py-36"
  >
    <img
      src={BRAND.symbol}
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute -right-16 top-1/2 -z-10 w-[420px] -translate-y-1/2 opacity-[0.07] blur-[1px] lg:-right-10 lg:w-[560px]"
    />
    <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(80%_60%_at_85%_50%,hsl(var(--navy-800)/0.7),transparent)]" />

    <div className="shell grid gap-16 lg:grid-cols-12 lg:gap-20">
      <div className="lg:col-span-6">
        <SectionHeading eyebrow={ABOUT.eyebrow} lines={ABOUT.headline} />
      </div>

      <div className="lg:col-span-6 lg:pt-20">
        <Reveal delay={0.1}>
          <div className="space-y-6">
            {ABOUT.paragraphs.map((text) => (
              <p key={text} className="text-sm leading-relaxed text-mist sm:text-base">
                {text}
              </p>
            ))}
          </div>
        </Reveal>
      </div>
    </div>

    <div className="shell mt-20 lg:mt-28">
      <div className="hairline" />
      <div className="grid gap-px bg-border/70 sm:grid-cols-3">
        {ABOUT.pillars.map((pillar, i) => (
          <Reveal key={pillar.title} delay={0.08 * i}>
            <div
              data-testid={`about-pillar-${i + 1}`}
              className="group h-full bg-navy-950 px-0 py-10 transition-colors duration-500 hover:bg-navy-900 sm:px-8"
            >
              <span className="font-mono text-[10px] tracking-[0.26em] text-aqua">
                0{i + 1}
              </span>
              <h3 className="mt-6 text-base font-medium uppercase tracking-[0.12em] text-offwhite md:text-lg">
                {pillar.title}
              </h3>
              <p className="mt-3 text-sm text-mist">{pillar.detail}</p>
              <span className="mt-8 block h-px w-10 bg-aqua/50 transition-all duration-500 group-hover:w-20" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
